import React from "react";

import AddNoteButtonMobile from "../Buttons/AddNoteButtonMobile";

function TopTitleNoteContainerMobile(props) {
  return (
    <div className="notes-button-container-mobile">
      <AddNoteButtonMobile title={props.title} handleOpen={props.handleOpen} />

      {/* <ButtonSortByDate /> */}
    </div>
  );
}

export default TopTitleNoteContainerMobile;
